import { useEventOffsetNote } from 'pages/search-transient-event-monthly/components/search-controls-event/EventOffsetNote';
import StorageUtils from '@spothero/utils/storage';
import { isOversizedFeatureEnabled } from 'utils/search-vehicle';
import { useSelector, useDispatch } from 'react-redux';
import { getParkingType } from 'store/selectors/selectors';
import { setSearchEventPopoverVisible } from 'store/search/search-actions';
import { useVehicleTooltipText } from 'pages/search-transient-event-monthly/components/search-controls/VehiclePopover';
export const TOOLTIPS = {
    event_offset_popover: 'event_offset_popover',
    search_vehicle_popover: 'search_vehicle_popover',
};
export const useTooltips = (tooltip) => {
    // searchEventOffsetPopoverVisible and searchOversizePopoverVisible are used to force re-render when the state changes
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const searchEventOffsetPopoverVisible = useSelector((state) => state.search.data.searchEventOffsetPopoverVisible);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const searchOversizePopoverVisible = useSelector((state) => state.search.data.searchOversizePopoverVisible);
    const dispatch = useDispatch();
    const parkingType = useSelector(getParkingType);
    const isOversizedEnabled = isOversizedFeatureEnabled(parkingType);
    const { text: vehicleText, handleClose: handleVehicleTooltipClose, } = useVehicleTooltipText({
        isOversizedEnabled,
    });
    const { text: eventText, hasOffsets: hasEventOffsets } = useEventOffsetNote({
        showActions: true,
    });
    const handleTooltipClose = () => {
        StorageUtils.set(`${tooltip}_visible`, false, 'session');
        if (tooltip === TOOLTIPS.search_vehicle_popover) {
            handleVehicleTooltipClose();
        }
        if (tooltip === TOOLTIPS.event_offset_popover) {
            dispatch(setSearchEventPopoverVisible(false));
        }
    };
    const sessionIsEventTooltipVisible = StorageUtils.get(`${TOOLTIPS.event_offset_popover}_visible`, 'session') !== false;
    const sessionIsVehicleTooltipVisible = StorageUtils.get(`${TOOLTIPS.search_vehicle_popover}_visible`, 'session') !== false;
    const isEventOffsetTooltipVisible = sessionIsEventTooltipVisible && hasEventOffsets;
    const isVehicleTooltipVisible = isEventOffsetTooltipVisible
        ? false // Don't show vehicle tooltip if event-offset tooltip is visible
        : sessionIsVehicleTooltipVisible && (vehicleText || '').length > 0;
    // Event offset tooltip takes precedence if available
    if (tooltip === TOOLTIPS.event_offset_popover) {
        return {
            isVisible: isEventOffsetTooltipVisible,
            text: eventText,
            handleClose: handleTooltipClose,
        };
    }
    // Show vehicle oversize tooltip only if the event offset is not showing
    if (tooltip === TOOLTIPS.search_vehicle_popover) {
        return {
            isVisible: isVehicleTooltipVisible,
            text: vehicleText,
            handleClose: handleTooltipClose,
        };
    }
    // Default state when no tooltip should be shown
    return {
        isVisible: false,
        text: null,
        handleClose: handleTooltipClose,
    };
};
